// extracted by mini-css-extract-plugin
export default {"errorInput":"CustomCheckbox_errorInput__B6ZlD","isSubscriptionCheckbox":"CustomCheckbox_isSubscriptionCheckbox__U3DFl"};